module.exports = __webpack_public_path__ + "img/ALoT1.5234f1bb.webp";